import moment from "moment";
import HelperMixin from "../../../Shared/HelperMixin.vue";
import PaginationHelper from "../../../Shared/PaginationHelper.vue";

export default {
    name: "WalletsOverview",
    mixins: [HelperMixin],
    components: { PaginationHelper },

    async created() {
        this.loginDetails = await this.CheckLoginStatus();

        if (!this.requireUserType([1])) return;

        this.GetInfo();
    },

    filters: {
        moment: function (date) {
            if (!date) return "—";
            return moment(date).format("DD/MM/YYYY");
        }
    },

    data() {
        return {
            pageNo: 1,
            pageSize: 10,
            pages: 0,

            ScreenTitle: "المحافظ الإلكترونية",
            ScreenTitleSingle: "محفظة",

            Info: [],
            Statistics: 0,

            Search: ""
        };
    },

    methods: {
        GetInfo(pageNo) {
            this.pageNo = pageNo || 1;

            if (!this.Search) this.$blockUI.Start();

            this.$http
                .GetWalletsOverview(this.pageNo, this.pageSize, this.Search)
                .then((response) => {
                    if (!this.Search) this.$blockUI.Stop();

                    const data = response.data || {};
                    this.Info = data.info || [];
                    this.pages = data.count || 0;

                    const s = data.statistics || {};
                    // API C# may return PascalCase — accept both shapes.
                    this.Statistics = {
                        walletCount: s.walletCount ?? s.WalletCount ?? 0,
                        totalFloat: s.totalFloat ?? s.TotalFloat ?? 0
                    };
                })
                .catch(() => {
                    if (!this.Search) this.$blockUI.Stop();
                    this.Info = [];
                    this.pages = 0;
                    this.Statistics = 0;
                });
        },

        // Search box (by name / phone) re-queries from page 1.
        GetInfoSearch() {
            this.GetInfo(1);
        },

        OnPageSizeChanged(size) {
            this.pageSize = Number(size) || 10;
            this.GetInfo(1);
        },

        Refresh() {
            this.Search = "";
            this.GetInfo(1);
        }
    }
};
